import type { TypePolicies } from '../../../utils';

export const typePolicies: TypePolicies = {
  Collection: {
    fields: {
      sortBys: {
        keyArgs: false,
      },
      groupBys: {
        keyArgs: false,
      },
      filters: {
        keyArgs: false,
      },
    },
  },
};
